module.exports = {"rAll":{"all":[7.8,28537],"kids":[8.5,373],"youth":[7.8,10315],"middle":[7.5,5265],"old":[7.1,765]},"rMale":{"all":[7.8,18447],"kids":[8.6,340],"youth":[7.8,9368],"middle":[7.5,4735],"old":[7.1,667]},"rFemale":{"all":[7.5,1685],"kids":[7.4,33],"youth":[7.7,867],"middle":[7.1,446],"old":[6.7,86]},"rUS":[7.3,3162],"rNonUs":[7.5,8551],"title":"Justice League (2017)","rNum":{"1":1290,"2":229,"3":294,"4":450,"5":902,"6":1843,"7":3379,"8":4253,"9":3332,"10":12565},"totalVotes":28537,"rAvg":7.8,"id":"tt0974015"}


//////////////////
// WEBPACK FOOTER
// ./src/data/Justice League (2017)Nov 18 0-03-49.json
// module id = 180
// module chunks = 0